import "./ClientAndProviderDetailsCardComponent.scss";
import CommonService from "../../services/common.service";
import {ImageConfig} from "../../../constants";
import moment from "moment";

interface ClientAndProviderDetailsCardComponentProps {
    type: 'client' | 'provider' | 'time' | 'facility';
    provider?: any;
    client?: any;
    appointmentDate?: any;
    appointmentTime?: any;
    facility?: any;
}

const ClientAndProviderDetailsCardComponent = (props: ClientAndProviderDetailsCardComponentProps) => {
    const {type, provider, client, appointmentDate, appointmentTime, facility} = props;

    return (
        <div className={'client-and-provider-details-card-component ts-col-lg-12 ts-col-md-12 ts-col-sm-12'}>
            {
                type === 'client' && <>
                    <div className="details-card-wrapper client-bg-color">
                        <div className={"details-card-title"}>Client Details</div>
                        <div className="details-and-icon-wrapper">
                            <div
                                className="name-logo-avatar">{CommonService.nameToInitials(client?.first_name + " " + client?.last_name)}</div>
                            <div className="details-wrapper">
                                <div className="details-name">{client?.first_name + " " + client?.last_name}</div>
                                <div
                                    className="details-description">{CommonService.formatPhoneNumber(client?.primary_contact_info?.phone)}</div>
                            </div>
                        </div>
                    </div>
                </>
            }

            {
                type === 'provider' && <>
                    <div className="details-card-wrapper provider-bg-color">
                        <div className={"details-card-title"}>Provider Details</div>
                        <div className="details-and-icon-wrapper">
                            <div
                                className="name-logo-avatar">{<ImageConfig.CheckoutProviderIcon/>}</div>
                            <div className="details-wrapper">
                                <div
                                    className="details-name">{provider?.first_name ? (provider?.first_name + " " + provider?.last_name) : 'N/A'}</div>
                                <div className="details-description">{provider?.professional_designation || 'N/A'}
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            }
            {
                type === 'time' && <>
                    <div className="details-card-wrapper time-bg-color">
                        <div className={"details-card-title"}>Date and Time</div>
                        <div className="details-and-icon-wrapper">
                            <div className="name-logo-avatar"><ImageConfig.CalenderCheckoutIcon/></div>
                            <div className="details-wrapper">
                                <div className="details-name">{moment(appointmentDate).format('DD-MMM-YYYY')}</div>
                                <div className="details-description">{CommonService.getHoursAndMinutesFromMinutes(appointmentTime)}</div>
                            </div>
                        </div>
                    </div>
                </>
            }
            {
                type === 'facility' && <>
                    <div className="details-card-wrapper client-bg-color">
                        <div className={"details-card-title"}>Facility Details</div>
                        <div className="details-and-icon-wrapper">
                            <div
                                className="name-logo-avatar">
                                <ImageConfig.FacilityIcon/>
                            </div>
                            <div className="details-wrapper">
                                <div className="details-name">{facility?.name}</div>
                                <div
                                    className="details-description">{facility?.address?.address_line}, {facility?.address?.city}, {facility?.address?.state}, {facility?.address?.country} {facility?.address?.zip_code}</div>
                            </div>
                        </div>
                    </div>
                </>
            }
        </div>
    );

};

export default ClientAndProviderDetailsCardComponent;
